import { render } from "./Checkbox.vue?vue&type=template&id=05007b29"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05007b29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05007b29', __exports__)) {
    api.reload('05007b29', __exports__)
  }
  
  module.hot.accept("./Checkbox.vue?vue&type=template&id=05007b29", () => {
    api.rerender('05007b29', render)
  })

}


export default __exports__